module.exports = __webpack_public_path__ + "media/images/gerb_minzdrava-c7cbb77989675e5f4cc7189fc799518f.png";